// import { useAuth } from "./app/useAuth";
import { useNavigate } from "react-router-dom";
import React from "react";

import Banner from "./components/layouts/banner";
import { GiToolbox, GiDna1, GiArchiveResearch } from "react-icons/gi";

export default function Main() {
    const navigate = useNavigate();

    const items = [
        {
            name: "Search",
            color: "#724116",
            textColor: "#bf7a43",
            icon: <GiArchiveResearch />,
            link: "/search",
        },
        {
            name: "Gnome Browser",
            color: "#188654",
            textColor: "#ffffff",
            icon: <GiDna1 />,
            link: "/gnome-browser",
        },
        {
            name: "Tools",
            color: "#c4e4f3",
            textColor: "#009cd7",
            icon: <GiToolbox />,
            link: "/tools",
        },
    ];

    return (
        <>
            <Banner />

            <div className="container-fluid mt-5">
                <div className="d-flex flex-wrap align-items-center justify-content-center gap-3">
                    {items.map((v, k) => {
                        return (
                            <div
                                key={k}
                                className="mt-3"
                                onClick={() => {
                                    navigate(v.link);
                                }}
                                style={{ minWidth: 200, maxWidth: 200, userSelect: "none", cursor: "pointer" }}
                            >
                                <div
                                    className="d-flex align-items-center justify-content-center"
                                    style={{ fontSize: "8rem", height: 200, borderRadius: "10%", backgroundColor: v.color, color: v.textColor }}
                                >
                                    {v.icon}
                                </div>
                                <div className="mt-2 fs-5 text-center">{v.name}</div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </>
    );
}
